import { ProfileV3Data } from './profile-load-v3';
import { recalculateStartLineAngle, calculateLengthTotal } from './profile-utils';

export function profileToStringV3(data: ProfileV3Data): string | null {
    if (!data.lines.length) {
        return null;
    }

    const lines = data.lines.map((line, index) => {
        let alpha = line.alpha;
        let direction = line.direction;
        if (!index) {
            const startLineAngle = recalculateStartLineAngle(line.alpha, line.direction, 0);
            alpha = startLineAngle.angle;
            direction = startLineAngle.direction;
        }

        return [
            line.restrictTrapeze ? 1 : 0,
            Math.abs(alpha),
            (direction + 1) / 2,
            line.length,
            line.length2,
            line.lengthMin,
            line.lengthMax,
            line.length2Min,
            line.length2Max,
            line.angleMin,
            line.angleMax,
        ].join(';');
    });

    return [
        'v3', data.paintSide,
        data.creaseLeft, data.edgeCreaseSizeMM,
        data.creaseRight, data.edgeCreaseSizeMM,
        lines.join('|'),
        data.profileTemplateName,
        calculateLengthTotal(data),
    ].join('%');
}
